import gql from 'graphql-tag';

const TOGGLE_DECREMENT_QUANTITY = gql`
	mutation toggleDecrementQuantity ($id: ID!) {
		toggleDecrementQuantity(id: $id) {
			id
			decrementQuantityOnSale
		}
	}
`;

export default TOGGLE_DECREMENT_QUANTITY;
